export default {"src":"/_next/static/image/public/images/ic_upload_thanks.4e2395a0a40912a16a3c6fd6c95d3a67.svg","height":111,"width":100};